/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Notified Booking API is for use from [Ciptex Race](https://ciptex.com/race), [Twilio Flex](https://www.twilio.com/flex) and [Twilio Studio](https://www.twilio.com/studio)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ListMetaData interface.
 */
export function instanceOfListMetaData(value) {
    if (!('pageSize' in value) || value['pageSize'] === undefined)
        return false;
    return true;
}
export function ListMetaDataFromJSON(json) {
    return ListMetaDataFromJSONTyped(json, false);
}
export function ListMetaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lastKey': json['lastKey'] == null ? undefined : json['lastKey'],
        'pageSize': json['pageSize'],
    };
}
export function ListMetaDataToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'lastKey': value['lastKey'],
        'pageSize': value['pageSize'],
    };
}
